import { Serie, Datum } from '@nivo/line';

export function getLineChartTickValues(data: Serie[]): number[] {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const numbers = Object.values(data).map((entry) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return Math.max(...Object.values(entry.data).map((p: Datum) => p.y as number));
  });

  const upper_limit = Math.ceil((Math.max(...numbers) + 10) / 10) * 10;
  const values = [];
  for (let i = 0; i <= upper_limit; i += 10) {
    values.push(i);
  }
  return values;
}